module.exports = __webpack_public_path__ + "static/award8-d1af6893c0cf9870f2a329739ff928b3.png";